module.exports = require("../utils/attachClickHandler");


//////////////////
// WEBPACK FOOTER
// external "../utils/attachClickHandler"
// module id = 7
// module chunks = 0